


























































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import TransacaoFinanceiraStore from '@/components/RemuneracaoMedica/financeiro/Store/TransacaoFinanceiraStore'
import ModalCriarEditarTransacaoFinanceira from '@/components/RemuneracaoMedica/financeiro/modais/ModalCriarEditarTransacaoFinanceira.vue'
import EventBus from '@/plugins/EventBus'

@Component({ components: { ModalCriarEditarTransacaoFinanceira } })
export default class ViewFinanceiroTransacaoFinanceira extends Vue {
  loading: boolean = false
  drawerFiltros: boolean = false
  menuInicio: boolean = false
  menuFim: boolean = false
  modalExcluir: boolean = false
  excluindo: boolean = false
  idParaExcluir: string = ''
  mode: string = 'CREATE'

  get store() {
    return getModule(TransacaoFinanceiraStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Descrição', value: 'descricao', align: 'left', sortable: false },
      { text: 'Código HIS', value: 'codigoHis', align: 'left', sortable: false },
      { text: 'Origem', value: 'origem', align: 'center', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Cadastrado em', value: 'createdOn', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get totalPaginas() {
    return Math.ceil(this.store.total / this.store.qtdPorPagina) || 1
  }

  get pagina() {
    return this.store.pagina
  }

  set pagina(value: number) {
    this.store.setPagina(value)
    this.getAll()
  }

  formatarData(value: string | null) {
    if (!value) return ''
    return moment(value).format('DD/MM/YYYY')
  }

  async getAll() {
    this.loading = true
    const response: any = await this.store.getAll()
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao carregar registros.', icon: 'warning', color: '#C62828' })
    }
    this.loading = false
  }

  aplicarFiltros() {
    this.store.setPagina(1)
    this.getAll()
  }

  limparFiltros() {
    this.store.limparFiltros()
    this.getAll()
  }

  novo() {
    this.mode = 'CREATE'
    this.store.limparItem()
    this.store.setModalCriarEditar(true)
  }

  editar(item: any) {
    this.mode = 'EDIT'
    this.store.setItem(item)
    this.store.setModalCriarEditar(true)
  }

  confirmarExclusao(id: string) {
    this.idParaExcluir = id
    this.modalExcluir = true
  }

  async excluir() {
    this.excluindo = true
    const response: any = await this.store.remover(this.idParaExcluir)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Excluído com sucesso!', icon: 'done', color: '#2E7D32' })
      this.modalExcluir = false
      await this.getAll()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao excluir.', icon: 'warning', color: '#C62828' })
    }
    this.excluindo = false
  }

  async mounted() {
    await this.store.carregarEnums()
    await this.getAll()
  }
}
